import React, { useState } from 'react';
import ComplaintsModal from './ComplaintsModal';

const ComplaintsButton = ({ products }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className="rd-icon-btn rd-icon-btn--mailbox"
        title="Жалобы и предложения"
        aria-label="Жалобы и предложения"
        onClick={handleClick}
      />

      {isOpen && (
        <ComplaintsModal
          onClose={handleClose}
          userName=""
          userData={null}
          products={products}
        />
      )}
    </>
  );
};

export default ComplaintsButton;
